var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "border d-flex align-items-center justify-content-center" },
    [
      _vm.isDaySelected
        ? _c("action-button", {
            attrs: {
              id: "calendar-return-btn",
              i: "fa fa-arrow-circle-left fa-lg color-gray-2"
            },
            on: { click: _vm.onReturnSelection }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }